import { Button } from '$components'
import { useCreateSupportTicketForm } from '.'

export function CreateSupportTicketFormControls() {
  const { onCancel, isLoading } = useCreateSupportTicketForm()

  return (
    <div className="flex gap-stack-roomy ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
        disabled={isLoading}
      >
        Submit
      </Button>
    </div>
  )
}
